export default __webpack_public_path__ + "static/media/PRODUCT_1.3b76dee8.jpg";